import { Add, Remove } from "@mui/icons-material";
import { Button, Typography } from "@mui/material";
import React from "react";

const CustomAccordionSummary = ({
  accordionItem,
  expandAccordion,
  setExpandAccordion,
  children,
}) => {
  const handleAccordionExpansion = () => {
    setExpandAccordion(!expandAccordion);
  };
  return (
    <div className="w-full p-2">
      <Button
        sx={{ textTransform: "none" }}
        size="small"
        className="relative flex w-full flex-row justify-between rounded-none bg-gray-100"
        onClick={handleAccordionExpansion}
      >
        {/* <div className="w-full flex flex-row justify-between bg-red-500 rounded-none relative"> */}
        <span className="px-2 text-left text-black">
          <Typography className="text-md">{accordionItem.group_name}</Typography>
        </span>
        {!expandAccordion ? (
          <Remove className="mr-2 text-sky-600" />
        ) : (
          <Add className="mr-2 text-sky-600" />
        )}
        {/* </div> */}
      </Button>
      {!expandAccordion && accordionItem && accordionItem.elements
        ? React.cloneElement(children, {
            accordionItem: accordionItem.elements,
          })
        : ""}
    </div>
  );
};

export default CustomAccordionSummary;
